import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { AuthState, User, Account } from '@/types/auth.types';

const initialState: AuthState = {
  user: null,
  account: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuth: (state, action: PayloadAction<{ user: User; account: Account }>) => {
      state.user = action.payload.user;
      state.account = action.payload.account;
    },
    clearAuth: (state) => {
      state.user = null;
      state.account = null;
    },
  },
});

export const { setAuth, clearAuth } = authSlice.actions;
export default authSlice.reducer;
